let blogTaghref = location.href;
let blogTagAr = blogTaghref.split('/');
let blogTag = blogTagAr.slice(-1);
var activeTag = 0;
let blogs_tags_a = Array.from(document.querySelectorAll('.blogs_tags_a'));

blogs_tags_a.forEach((item)=>{
  //console.log(item.innerText.toLowerCase().replace(/\s+/g, '-'), 'hellomr');
  if(item.innerText.toLowerCase().replace(/\s+/g, '-') == blogTag){
    item.classList.add('blogs_tags_active');
    activeTag++;
  }
})

if(activeTag ==0){
  blogs_tags_a[0].classList.add('blogs_tags_active');
}